<template>
  <section id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <table class="layui-table">
          <thead>
            <tr>
              <th>类型</th>
              <th>所属商家</th>
              <th>店铺名称</th>
              <th>站点</th>
              <th>使用状态</th>
              <th>授权时间</th>
              <th>服务费率(%)</th>
            </tr>
          </thead>
          <tbody>
            <tr class="order_box" v-for="(item,index) in list" v-bind:key="index" :class="{'expired':item.expired}">
              <td>
                <i v-if="item.main_account_id">全球店铺</i>
                <i v-else>普通店铺</i>
              </td>
              <td>
                <i v-if="item.merchant_name" v-text="item.merchant_name"></i>
                <i v-else>-</i>
              </td>
              <td v-text="item.name"></td>
              <td v-text="item.country"></td>
              <td style="min-width: 60px;">
                <i class="status-box status-box-green">已授权</i>
              </td>
              <td v-text="item.auth_time"></td>
              <td>
                <div class="commission-box commission-active">
                  <input :disabled="!item.active" v-model="item.commission" class="commission ">
                  <i v-on:click="ItemActive(index)" :class="{'fa-edit':!item.active,'fa-check':item.active}" class="commission-icon fa"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

      <!-- 分页 -->
      <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    </div>
  </section>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        isLoding: true,
        ishow: "none",
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        id: null,
        item: null,
        page: 1,
        count: 0,
        total: 0,
        list: [],
        page_num:20
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("管理",self.$route.name);
      let mid = self.$route.query.main_account_id
      let id = self.$route.query.shop_id

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        form.render();
        self.GetList();
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      GetList(ref) {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_list/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;
          var json = response.data;
          var datas = json.datas;
          if (json.code == 200) {
            if(ref){
              self.GetList(); //店铺更新
            }
            if (datas.page) {
              for (let i in datas.list) {
                datas.list[i].active = false;
                datas.list[i].auth_time = self.timestampToTime(datas.list[i].auth_time);
              }
              self.list = datas.list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            } else {
              self.list = [];
              self.count = 0; //页数
              $('.pagebox').hide();
            }
          } else if (json.code == 401) {
            self.GoToPage("/");
          } else {
            console.log(json.msg);
          }

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      ItemActive (ix) {
        if(self.list[ix].active){
          self.EditItem(ix);
        }else{
          self.list[ix].active = true;
        }
      },
      EditItem (ix) {
        self.loading = true;
        $.ajax({
          url: self.GetServerUrl() + "/set_shop_commission/",
          type: 'post',
          data: {
            id: self.list[ix].id,
            commission:self.list[ix].commission
          },
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          },
          success: function(res) {
            self.list[ix].active = false;
            self.loading = false;
            var json = JSON.parse(res);
            if (json.code == 200) {
              self.ToastFun(0, json.msg); //弹窗提醒
              self.GetList();
            } else {
              self.ToastFun(1, json.msg); //弹窗提醒
            }
          },
          error: function(error) {
            self.loading = false;
            self.ToastFun(2, error); //弹窗提醒
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }

  .shop-nav-two {
    display: none;
  }

  .commission-box{
    width: 100px;
    position: relative;
    border:1px solid #E0E0E0;
  }
  .commission{
    width: 50px;
    padding:0 10px;
    height: 30px;
    border:0;
  }
  .commission-active{
    background-color: #f9f9f9;
  }
  .commission-icon{
    cursor: pointer;
    margin-left: 10px;
    font-size: 18px;
    position: absolute;
    top:7px;
    right:5px;
    z-index: 9;
  }
  .commission-icon:hover{
    color: #007AFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/Shop.vue